import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/esm/Container";
import Row from "react-bootstrap/esm/Row";
import Goal from "./Goal";
import Button from "react-bootstrap/esm/Button";
import toast, { Toaster } from "react-hot-toast";
function Goals(props) {
  const [guess, setGuess] = useState([]);
  const [attempts, setAttempts] = useState(0);
  const [guessedAnswer, setGuessedAnswer] = useState([]);
  const [passHint, setPassHint] = useState();
  const [hintToggle, setHintToggle] = useState(false);

  const answerCheck = () => {
    if (guess.length === 1) {
      props.setPlay(true);
    }
    if (guess.length > 0 && guess.length === props.words.length) {
      if (guessedAnswer === props.answer) {
        props.setPlay(false);
        toast(
          "Congratulations, you've solved the puzzle. The answer was " +
            props.answer +
            ".",
          {
            duration: 6000,
            position: "bottom-center",
          }
        );
        props.setTimesPlayed((prevPlayed) => prevPlayed + 1);
      } else {
        toast(
          "It looks like something is incorrect. If you need help use the yellow hint button at the top right corner.",
          {
            duration: 5000,
            position: "bottom-center",
          }
        );
      }
    } else {
    }
  };

  const hint = () => {
    if (guessedAnswer.length > 0) {
      const currentUserGuess = guessedAnswer.split(" ");
      const correctAnswer = props.answer.split(" ");

      let indexToChange = currentUserGuess.findIndex((word, x) => {
        return word !== correctAnswer[x];
      });
      if (indexToChange === -1) {
        indexToChange = currentUserGuess.length;
      }
      setPassHint(correctAnswer[indexToChange]);
    } else {
    }
    setHintToggle(true);
  };

  useEffect(() => {
    answerCheck();
  }, [attempts]);

  return (
    <>
      <Container
        style={{
          width: "100%",
          height: "375px",
          backgroundColor: "rgb(112 0 169 / 47%)",
          borderRadius: "25px",
        }}
      >
        <Row
          style={{
            height: "45px",
            borderBottom: "solid 2px #333",
          }}
        >
          {" "}
          <div style={{ textAlign: "right" }}>
            <Button
              style={{ height: "35px", width: "100px", margin: "5px" }}
              variant="warning"
              onClick={hint}
            >
              Hint?
            </Button>
          </div>
        </Row>
        <Row style={{ height: "150px" }}>
          <div
            style={{
              textAlign: "center",
              fontSize: "80px",
              color: "white",
            }}
          >
            <b>{props.phrase}...</b>
          </div>
          <Row style={{ marginTop:'25px',height: "200px"}}>
          {props.words.map((word, x) => (
            <Goal
              key={word.id}
              word={word}
              setGuess={setGuess}
              guess={guess}
              setAttempts={setAttempts}
              x={x}
              setGuessedAnswer={setGuessedAnswer}
              errorChecking={props.errorChecking}
              answer={props.answer}
              passHint={passHint}
              hint={hintToggle}
              setHintToggle={setHintToggle}
            />
          ))}
          </Row>
        </Row>
        <Toaster />
      </Container>
    </>
  );
}

export default Goals;
